export default __webpack_public_path__ + "static/media/art-octopus.cd71110f.png";